export default "__VITE_ASSET__dYyPXkCv__"